import { GET_PAYMENTS_LIST } from '../cash/API';

const query = {
  payments: GET_PAYMENTS_LIST,
};

export { query };
